<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <material-card
          color="info"
          title="Login"
          text="Please enter your email and password"
        >
          <v-fade-transition leave-absolute>
            <v-sheet
              v-if="showLoginError"
              dark
              class="d-flex pa-2"
              color="red lighten-1"
              elevation="6"
            >
              Your email or password is incorrect. Or you tried to register with
              an email that already exists in our system.
              <br />Please try again.
            </v-sheet>
          </v-fade-transition>
          <v-card-text>
            <v-btn @click="onSignin('google')" block color="blue darken-2" dark
              >Login with Google</v-btn
            >
            <div style="text-align: center;font-weight: bold;" class="my-3">
              - OR -
            </div>
            <v-form>
              <v-text-field
                v-model="details.email"
                :rules="emailRules"
                prepend-icon="mdi-account"
                name="email"
                label="Email"
                type="text"
              />
              <v-text-field
                id="password"
                :rules="[(v) => !!v || 'Item is required']"
                v-model="details.password"
                v-if="!register"
                prepend-icon="mdi-lock"
                name="password"
                label="Password"
                type="password"
                @keyup.enter="onSignin('email')"
              />
              <v-text-field
                id="password"
                :rules="[(v) => !!v || 'Item is required']"
                v-model="details.password"
                v-if="register"
                prepend-icon="mdi-lock"
                name="password"
                label="Password"
                type="password"
              />
              <v-text-field
                v-if="register"
                v-model="details.confirmPassword"
                :rules="passwordMatch"
                prepend-icon="mdi-blank"
                label="Confirm Password"
                type="password"
                @keyup.enter="onSignin('newUser')"
                required
              ></v-text-field>
              <p @click="forgotPasswordDialog = true" style="cursor: pointer;">
                Forgot Password?
              </p>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              v-if="!register"
              @click="register = true"
              color="grey lighten-2"
              >Register</v-btn
            >
            <v-btn
              v-if="register"
              @click="register = false"
              color="grey lighten-2"
              >Cancel</v-btn
            >
            <v-spacer />
            <v-btn
              v-if="!register"
              :loading="signInLoading"
              color="info"
              @click="onSignin('email')"
              >Login</v-btn
            >
            <v-btn
              v-if="register"
              :loading="signInLoading"
              color="info"
              @click="onSignin('newUser')"
              >Confirm Registration</v-btn
            >
          </v-card-actions>
        </material-card>
      </v-flex>
      <v-dialog v-model="forgotPasswordDialog" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <h3 class="heading">Forgot Password?</h3>
          </v-card-title>
          <v-card-text>
            <v-container py-0>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    class="cyan-input"
                    v-model="forgottenPasswordEmail"
                    label="Email"
                  />
                </v-flex>
                <v-flex xs12 style="text-align: right !important;">
                  <v-btn
                    class="mx-0 font-weight-light"
                    @click="forgotPasswordDialog = !forgotPasswordDialog"
                    color="error"
                    style="margin-right: 10px !important;"
                    >close</v-btn
                  >
                  <v-btn
                    class="mx-0 font-weight-light"
                    @click="
                      forgotPasswordDialog = !forgotPasswordDialog;
                      forgotPassword();
                    "
                    color="primary"
                    style="margin-right: 10px !important;"
                    >Send Reset Request</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      signInLoading: false,
      register: false,
      details: {},
      showLoginError: false,
      forgotPasswordDialog: false,
      forgottenPasswordEmail: "",
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
      passwordMatch: [
        (v) => {
          return v === this.details.password || `Passwords don't match`;
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["user"]),
  },
  methods: {
    onSignin(method) {
      if (typeof method === "undefined") {
        method = "email";
      }
      this.signInLoading = true;
      this.showLoginError = false;
      this.$store
        .dispatch("user/signIn", {
          email: this.details.email,
          password: this.details.password,
          confirmPassword: this.details.confirmPassword,
          method: method,
        })
        .then(() => {
          if (this.user.auth === null) {
            this.showLoginError = true;
            this.signInLoading = false;
          } else if (method === "newUser") {
            this.$router.push(`/userProfile`);
            this.signInLoading = false;
          }
        });
    },
    forgotPassword() {
      this.$store
        .dispatch("user/passwordReset", this.forgottenPasswordEmail)
        .then(() => {
          this.$swal({
            title: "Success!",
            text: `Email Reset link has been sent to ${this.forgottenPasswordEmail}`,
            type: "success",
            confirmButtonText: "Ok",
          });
        });
    },
  },
};
</script>
